import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const TechnicianClocking = {
	name: NAME,
	apiProvider,
	router,
};
